import '../shared/sentry/init'

import * as tc from 'finviz-charts/app/lib-export'
import React from 'react'
import ReactDOM from 'react-dom'

import { Search } from '../../main/components/search'
import { withQueryClientContext } from '../shared/components/QueryClientContext'
import { isIpad, isMobile } from '../shared/isMobile'
import { ready } from '../shared/ready'
import ScamNotice from './scam-notice'
import OldSearch, { SearchProps } from './search'
import Settings from './settings-dropdown'
import { Time } from './time'

window.FLibs.Charts = {
  Utils: tc.Utils,
  convertTa: tc.convertTa,
  Quote: tc.Quote,
}

/**
 * The script below allows iPads in landscape mode to size the page naturally
 * instead of forcing 1024px viewport which results in a zoomed in view
 */
if (isIpad()) {
  const minViewport = 1024
  const viewportString = { fixed: `width=${minViewport}`, fluid: 'width=device-width, initial-scale=1.0' }

  const getViewportWidth = () => Math.round(window.innerWidth * (window.visualViewport?.scale || 1))
  const setViewport = (fixedViewport: boolean) =>
    document
      .querySelector('meta[name=viewport]')
      ?.setAttribute('content', fixedViewport ? viewportString.fixed : viewportString.fluid)

  let viewportWidth = getViewportWidth()

  setViewport(viewportWidth <= minViewport)

  window.addEventListener('resize', function () {
    const newViewportWidth = getViewportWidth()
    // iOS fires resize on overscroll
    if (viewportWidth === newViewportWidth) return
    viewportWidth = newViewportWidth
    setViewport(newViewportWidth <= minViewport)
  })
}

function renderAccountDropdown(element: Element | null) {
  if (!element) return

  ReactDOM.render(<Settings />, element)
}

/**
 * Display scam notice when language matches 'ru' or 'et'
 */
function renderScamNotice(element: Element | null) {
  const languages = navigator.languages instanceof Array ? navigator.languages : [navigator.language]
  const targetLanguages = ['ru', 'et']
  const isTargetLanguage = languages
    .map((language) => language.toLowerCase())
    .some((language) => targetLanguages.some((targetLanguage) => language.includes(targetLanguage)))

  if (!element || !isTargetLanguage) return

  ReactDOM.render(<ScamNotice />, element)
}

const hasEnabledRedesign = FinvizSettings.hasRedesignEnabled
function renderSearch(props?: SearchProps, retries = 0) {
  const container = document.getElementById('search')

  if (!container && retries < 10) {
    setTimeout(() => renderSearch(props, retries + 1), 300)
  }

  if (!hasEnabledRedesign) {
    return ReactDOM.render(<OldSearch {...props} />, container)
  }

  const SearchComponent = withQueryClientContext(Search)
  return ReactDOM.render(
    <SearchComponent
      defaultPlacement="bottom-start"
      theme="navigationBar"
      size="medium"
      placeholder="Search ticker, company or profile"
      autoFocus={props?.focus}
      isMatchInputAndBoxWidth
    />,
    container
  )
}

let searchAutoFocus = false
ready(function () {
  if (hasEnabledRedesign) {
    renderSearch({ focus: searchAutoFocus })
  } else {
    renderSearch()
  }
  const timeContainer = document.getElementById('time')
  if (timeContainer) ReactDOM.render(<Time className="w-full text-[11px] text-white" />, timeContainer)

  renderAccountDropdown(document.getElementById('account-dropdown'))
  renderScamNotice(document.getElementById('scam-notice'))
})

window['SearchFocus'] = function () {
  if (hasEnabledRedesign && !isMobile()) {
    searchAutoFocus = true
  } else if (!hasEnabledRedesign) {
    renderSearch({ focus: true })
  }
}
